// The app-wide Pinia instance, exported so detached mini-apps (e.g. the BPMN
// reference-selector popup) share the main app's stores instead of creating
// fresh ones — a fresh Pinia re-instantiates every store it touches, and their
// immediate watchers refire all initial fetches (get_worktree, get_process, …).
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

export const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
